var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 8 13"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M7.41 1.66L2.83 6.25l4.58 4.59L6 12.25l-6-6 6-6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }